import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propShape, propFunc, propNumber, } from '../../../../../helpers/custom-prop-types';
import RfpAddButton from '../../../../Ui/Rfp/RfpAddButton';
const RfpQuestionOnlineQuestionsFieldArray = (props) => {
    const { addObject, canAddQuestionCount, fields, render } = props;
    const onClickDelete = useCallback((e) => {
        const index = parseInt(e.currentTarget.value, 10);
        fields.remove(index);
    }, [fields]);
    const onClickAdd = useCallback(() => {
        fields.push(addObject);
    }, [fields, addObject]);
    return (_jsxs("div", Object.assign({ className: 'rfp_question_form_question' }, { children: [_jsx("div", Object.assign({ className: 'rfp_question_form_question_list' }, { children: fields.map((field, index) => render({
                    field,
                    index,
                    length: fields.length,
                    onClickDelete,
                })) })), fields.length < canAddQuestionCount && (_jsx("div", Object.assign({ className: 'rfp_question_form_question_action' }, { children: _jsx(RfpAddButton, { onClick: onClickAdd, text: '質問を追加' }) })))] })));
};
RfpQuestionOnlineQuestionsFieldArray.propTypes = {
    addObject: propShape().isRequired,
    canAddQuestionCount: propNumber().isRequired,
    fields: propShape().isRequired,
    render: propFunc().isRequired,
};
export default RfpQuestionOnlineQuestionsFieldArray;
